// ─────────────────────────────────────────────────────────────────────────────
// src/config.js  —  ✅ CHANGE YOUR COMPANY NAME & ICON HERE
//
// This is the ONLY file you need to edit to rebrand the entire website.
// Every page, logo, footer, legal text, and WhatsApp link reads from here.
// ─────────────────────────────────────────────────────────────────────────────

const config = {
  // ── LOGO & BRAND ─────────────────────────────────────────────────────────
  //
  // logoIcon: any emoji  OR  a URL string to an image file
  //   Emoji example:   logoIcon: '🌾'
  //   Image example:   logoIcon: '/logo.png'   (place file in public/ folder)
  //
  // logoIcon: "🌱", // ← CHANGE: company icon / emoji
  logoIcon: "/dbk_icon.png", // ← CHANGE: company icon / emoji

  // Two-line logo text shown in the navbar
  companyLine1: "Danti Wada", // ← CHANGE: top line   (e.g. "Green Farm")
  companyLine2: "Beej Kendra", // ← CHANGE: bottom line (e.g. "Seeds & Co.")

  // Full company name used in page titles, footer, and legal pages
  companyFull: "Danti Wada Beej Kendra", // ← CHANGE: full legal name

  // Year shown in hero badge "EST. XXXX"
  established: "1990", // ← CHANGE: founding year

  // Prefix for product SKU codes shown on product detail (e.g. "DBK-001")
  skuPrefix: "DBK", // ← CHANGE: 2-4 letter prefix

  // ── CONTACT ──────────────────────────────────────────────────────────────
  phone: "+91 9909000682", // ← CHANGE: display phone number
  whatsapp: "919909000681", // ← CHANGE: WhatsApp number (no + or spaces)
  email: "dantiwadakrushibijkendra@gmail.com", // ← CHANGE: email address

  // Address — in 3 languages (shown in Contact page and Footer)
  address: {
    en: "On Tirupati Market Road, Bhabhar, Banaskantha, Gujarat – 385320",
    hi: "तिरुपति मार्केट रोड पर, भाभर, बनासकांठा, गुजरात – 385320",
    gu: "તિરૂપતિ માર્કેટ રોડ પર, ભાભર, બનાસકાંઠા, ગુજરાત – 385320",
  },

  // Google Maps — used for the map link on the Contact page
  mapQuery: "Bhabhar+Gujarat", // ← CHANGE: search query for Google Maps
  mapLabel: "Bhabhar, Banaskantha, Gujarat", // ← CHANGE: display label under the map

  // Small location text shown in the Hero section below the EST. badge
  heroLocation: "Bhabhar, Banaskantha, Gujarat", // ← CHANGE: hero location text

  // Business hours — shown on Contact page
  hours: {
    en: "Mon–Sat: 9:00 AM – 6:00 PM\nSunday: 10:00 AM – 2:00 PM",
    hi: "सोम–शनि: 9:00 AM – 6:00 PM\nरविवार: 10:00 AM – 2:00 PM",
    gu: "સોમ–શનિ: 9:00 AM – 6:00 PM\nરવિવાર: 10:00 AM – 2:00 PM",
  },

  // Footer tagline — small text below the logo in the footer
  footerDesc: {
    en: "Gujarat's trusted seed supplier since 1990.",
    hi: "1990 से गुजरात के विश्वसनीय बीज आपूर्तिकर्ता।",
    gu: "1990 થી ગુજરાતના વિશ્વસ્ત બીજ સપ્લાયર.",
  },
};

export default config;
